enum Sex {
  Male = 0,
  Female = 1,
  Other = 2,
  None = 3,
}

export default Sex;
